import React from "react";
import PropTypes from "prop-types";
import "./style.css";

const style = {
  searchWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "50px 0px",
    width: "70%",
    position: "relative"
  },
  searchInput: {
    backgroundColor: "#b5b5b6",
    borderRadius: "32px",
    border: "none",
    width: "100%"
  },
  searchIconWrapper: {
    backgroundColor: "#00acc9",
    height: "72px",
    width: "72px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    left: "0px",
    borderRadius: "100%"
  }
};

const SearchBox = props => (
  <div style={props.searchWrapperStyle ? props.searchWrapperStyle : style.searchWrapper}>
    {
      !props.hideSearchImage && <div style={style.searchIconWrapper}>
        <img src={require("assets/images/search-white-nobg.png")} alt="Search" />
      </div>
    }
    <input
      className="defaultCustomSearchBox"
      value={props.value}
      placeholder={props.placeholder ? props.placeholder : "Search"}
      style={props.searchInputStyle ? props.searchInputStyle : style.searchInput}
      onChange={(e) => props.onChange(e)}
    />
    {props.children}
  </div>
);

SearchBox.prototype = {
  searchWrapperStyle: PropTypes.object,
  hideSearchImage: PropTypes.bool,
  placeholder: PropTypes.string,
  searchInputStyle: PropTypes.object
}

export default SearchBox;
